import React from 'react';
import { ActivityProps } from './AllServices';
import { DropdownOptions } from '../dropdown/Dropdown';
import { ActivityDisplay } from './ActivityDisplay';

export const ActivityItem = React.memo(
    (props: { item: DropdownOptions; activityProps: ActivityProps }) => {
        try {
            const {
                item,
                activityProps,
                activityProps: { featureFlaggedActivities },
            } = props;
            const activityName = item?.item?.Item;

            if (item && activityName) {
                const featureFlaggedActivityDetected =
                    featureFlaggedActivities?.find(
                        ({ name }) => name === activityName,
                    );

                if (!featureFlaggedActivityDetected) {
                    return (
                        <ActivityDisplay
                            item={item}
                            activityProps={activityProps}
                        />
                    );
                } else if (featureFlaggedActivityDetected?.enabled) {
                    return (
                        <ActivityDisplay
                            item={item}
                            activityProps={activityProps}
                        />
                    );
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch {
            return null;
        }
    },
);
